import { render, staticRenderFns } from "./elearea4.vue?vue&type=template&id=4dd3645e&scoped=true&"
import script from "./elearea4.vue?vue&type=script&lang=js&"
export * from "./elearea4.vue?vue&type=script&lang=js&"
import style0 from "./elearea4.vue?vue&type=style&index=0&id=4dd3645e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3645e",
  null
  
)

export default component.exports